import { Field } from "typegraph";
import Tag from "./Tag";
import { Status } from "common/constants/Constants";


enum Completion {
	NotStarted = "NotStarted",
	Started = "Started",
	Incomplete = "Incomplete",
	Completed = "Completed",
	Passed = "Passed",
	Failed = "Failed"
}

class SubscriptionTag {

	@Field()
	public type: string;

	@Field({entity: Tag})
	public tag: Tag;
}

export class Subscription {

	@Field()
	public id: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public timeSpent: number;

	@Field()
	public completion: Completion;

	@Field()
	public completedOn: string;

	@Field()
	public status: Status;

	@Field()
	public lastVisited: string;

	@Field({
		entity: SubscriptionTag,
		includeIf: (data: any) => data.loadPretestTags
	})
	public tags: SubscriptionTag[] | null;

	@Field()
	public score: number;

}




// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Subscription.ts